<template>
	<div :style="logo" class="logo"></div>
</template>

<script>
import store from "../../store";

export default {
	name: "ScreensaverLogo",
	computed: {
		logo() {
            let logo = "../img/logo.svg";

            if(store.state.settings.design.logo != null && store.state.settings.design.logo != false)
            {
                logo = store.state.settings.design.logo;
            }

			return `background-image: url(${logo})`; //background-image: url(../img/logo.svg);
		},
	},
};
</script>

<style scoped>
	.logo {
		background-repeat: no-repeat;
    	background-size: 50%;
		background-position-x: center;
		background-position-y: 45%;
		width: 100%;
		height: 100%;
	}
</style>